import { render, staticRenderFns } from "./SnippetPopup.vue?vue&type=template&id=a9038e0e"
import script from "./SnippetPopup.vue?vue&type=script&lang=ts"
export * from "./SnippetPopup.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports